import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthUser } from './authApi';

interface AuthState {
  token: string | null;
  user: AuthUser | null;
  status: 'unknown' | 'loading' | 'authed' | 'anon';
  setSession: (token: string, user: AuthUser) => void;
  setUser: (user: AuthUser) => void;
  setStatus: (s: AuthState['status']) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      status: 'unknown',
      setSession: (token, user) => set({ token, user, status: 'authed' }),
      setUser: (user) => set({ user }),
      setStatus: (status) => set({ status }),
      clear: () => set({ token: null, user: null, status: 'anon' }),
    }),
    {
      name: 'cd:auth',
      partialize: (s) => ({ token: s.token, user: s.user }),
    },
  ),
);
